import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  ADMIN_PARTNERS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

import {
  AFFILIATES_PENDING_APPROVE_ROUTE_NAME,
  AFFILIATES_PENDING_LIST_ROUTE_NAME,
  AFFILIATES_PENDING_PERMISSIONS,
  AFFILIATES_PENDING_PROFILE_ROUTE_NAME,
  AFFILIATES_PENDING_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATES_PENDING,
} from './constants';
import { getTranslationKeys } from './translations';

export class AffiliatesPendingModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: AFFILIATES_PENDING_ROUTE_NAME,
      path: 'new-partners',
      permission: AFFILIATES_PENDING_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'AffiliatesPendingListPage',
    });

    router.addChildRoute(AFFILIATES_PENDING_ROUTE_NAME, {
      name: AFFILIATES_PENDING_LIST_ROUTE_NAME,
      path: '',
      permission: AFFILIATES_PENDING_PERMISSIONS.SHOW,
      component: () => import('./pages/AffiliatesPendingListPage/AffiliatesPendingListPage.vue'),
    });

    router.addChildRoute(AFFILIATES_PENDING_ROUTE_NAME, {
      name: AFFILIATES_PENDING_PROFILE_ROUTE_NAME,
      path: 'view/:id/:tab',
      permission: AFFILIATES_PENDING_PERMISSIONS.SHOW,
      component: () => import('@modules/affiliates-profile/pages/AffiliatesProfilePage/AffiliatesProfilePage.vue'),
    });

    router.addChildRoute(AFFILIATES_PENDING_ROUTE_NAME, {
      name: AFFILIATES_PENDING_APPROVE_ROUTE_NAME,
      path: 'accept/:id',
      permission: AFFILIATES_PENDING_PERMISSIONS.REQUEST,
      component: () => import('./pages/AffiliatesPendingApprovePage/AffiliatesPendingApprovePage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_PARTNERS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'PARTNERS_NEW_PARTNERS'),
      to: {
        name: AFFILIATES_PENDING_LIST_ROUTE_NAME,
      },
      permission: AFFILIATES_PENDING_PERMISSIONS.SHOW,
      id: AFFILIATES_PENDING_LIST_ROUTE_NAME,
      order: 20,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATES_PENDING, getTranslationKeys);
  }
}
